<template>
  <div class="container">
    <div class="row">
      <div class="col-xs-12">
        <h3 class="title">Serviços Vale-pedágio</h3>
        <hr class="h-rule-yellow">
        <hr class="h-rule-side-yellow">
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 margin-b10">
        <h3 class="bold upper">TAG Exclusiva para VPO: Pensou Vale-pedágio, pensou Move Cargo.</h3>
        <p>Totalmente digital, SEM CUSTO e fácil de usar.</p>
      </div>
    </div>

    <vpo type="adhesion"></vpo>

  </div>
</template>
<script>
  import vpo from "./plans/vpo.vue"

  export default {
    components: {vpo}
  }
</script>
<style scoped lang="scss">
  .title.plan {
    color: white;
    font-size: 1.36em;
    margin-top: 16px;
  }
  .recharge-info {
    margin-top: -5px;
  }
  .icon-plans-table {
    color: #000;
    font-size: 3em;
  }
  .top-margin-up {
    margin: -10px 0 0
  }
  .bail-value {
    background-color: #f4d000 !important;
    font-size: 16px;
  }
  .row-button {
    height: 82;
    padding: 21px;
    .btn-primary {
      background: transparent;
      border: 2px solid white;
      padding: 10px 36px;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
    }
    .btn-primary:hover {
      background: white;
      color: #503066;
    }
    .btn-primary:active {
      background: rgba(0,0,0,0.2);
      border: 2px solid white;
      color: white;
    }
    .btn-default {
      background: transparent;
      border: 2px solid #613A7D;
      color: #613A7D;
      padding: 10px 36px;
      box-shadow: none !important;
      -webkit-box-shadow: none !important;
      -moz-box-shadow: none !important;
    }
    .btn-default:hover {
      background: #503066;
      border: 2px solid #503066;
      color: white;
    }
    .btn-default:active {
      background: #341045;
    }
  }
  .height-112 {
    height: 140px;
    a {
      color: white;
      text-decoration: underline;
    }
  }
  .height-82 {
    height: 82px;
  }
  .height-72 {
    height: 72px;
    .form-control {
      font-size: 1.4em;
      width: 200px;
      text-align: center;
      height: 40px;
      margin: 0px -6px;
    }
    a {
      color: white;
      text-decoration: underline;
    }
  }
  .striped-line {
    background-color: #ebebeb;
  }
  .striped-line-purple {
    background-color: #503066;
  }
  p {
    line-height: 15px;
  }
  .btn-sm {
    padding: 5px 30px 7px !important;
  }
  .btn-charge {
    border: 2px solid #b5b5b5;
    padding: 10px;
    color: black;
    margin-top: 5px;
    i {
      font-size: 1.2em;
    }
  }
  .icon-checkmark {
    border: 2px solid white;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    padding: 3px;
    font-size: 0.8em;
    &.align-icon-left-white {
      left: -22px;
    }
  }
  .icon-empty {
    width: 21px;
    height: 21px;
    border: 2px solid #613A7D;
    -webkit-border-radius: 50%;
    border-radius: 50%;
    &.align-icon-left {
      left: -22px;
    }
  }

  .first-col-box {
    width: 140px;
    .height-112,
    .height-82 {
      padding: 15px 10px;
      background-color: #ebebeb;
    }
    .height-72 {
      padding: 5px 10px;
      background-color: #ebebeb;
    }
    & div:nth-child(odd) {
      background-color: rgba(0,0,0,0.05);
    }
  }

  .second-col-box {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    color: white;
    background-color: #6ea500;
    .height-112 {
      /*height: 110px;*/
    }
    .height-72:last-child {
      height: 70px;
    }

  }

  .second-col-box,
  .third-col-box,
  .fourth-col-box,
  .fifith-col-box {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    .height-112 {
      padding: 15px 10px;
      p {
        /*padding: 0px 50px;*/
        /*color: #613A7D;*/
      }
    }
    .height-72 {
      padding: 10px 30px;
      /*background-color: #ebebeb;*/
    }
    ul {
      width: 144px;
      margin: 0px auto;
      padding-left: 20px;
      li {
        list-style-type: disc;
        text-align: left;
      }
    }
    & div:nth-child(even) {
      background-color: rgba(0,0,0,0.05);
    }
  }
  .third-col-box {
    /*border: 0px solid #000;*/
    background-color: #3472ce;
    color: white;
  }
  .fourth-col-box {
    background-color: #f4d000;
    color: #613A7D;
    .title, a{
      color: #613A7D;
    }
  }
  .fifith-col-box {
    background-color: #57377a;
    color: white;
  }
  .btn-default,
  .btn-default:hover,
  .btn-default:active {
    -webkit-box-shadow: none;
    box-shadow: none;
    border: 0px;
  }
  .padding-12 {
    padding-top: 12px;
    padding-bottom: 12px;
  }
  .padding-18 {
    padding-top: 18px !important;
    padding-bottom: 18px !important;
  }
  .padding-20 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }
  .padding-23 {
    padding-top: 23px !important;
    padding-bottom: 23px !important;
  }
  .padding-28 {
    padding-top: 28px !important;
    padding-bottom: 28px !important;
  }
  .padding-t16 {
    padding-top: 16px !important;
  }
  .padding-t25 {
    padding-top: 25px !important;
  }
  .padding-t28 {
    padding-top: 28px !important;
  }
  .padding-t30 {
    padding-top: 30px !important;
  }
  .padding-t45 {
    padding-top: 45px;
  }
  .border-radius-top {
    -webkit-border-radius: 10px 10px 0px 0px;
    border-radius: 10px 10px 0px 0px;
  }
  .border-radius-bottom {
    -webkit-border-radius: 0px 0px 10px 10px;
    border-radius: 0px 0px 10px 10px;
  }

  .plain-box {
    width: calc(100% - 155px);
    float: left;
  }

  @media screen and (max-width: 991px) {
    .plain-box {
      padding: 0 15px;
      width: 100%;
    }
    .first-col-box {
      display: none;
    }
    .recharge-info {
      margin-bottom: 20px;
    }
    .height-72-big {
      height: auto;
    }
    .height-112,
    .second-col-box .height-112,
    .third-col-box .height-112 {
      height: auto !important;
    }
  }

  @media screen and (max-width: 500px) {
    p {
      padding: 0 !important;
    }
    .plain-box {
      padding: 0 15px;
      width: 100%;
    }
    .btn-primary {
      padding: 10px 30px;
    }
    .box-recharge,
    .box-recharge-last {
      float: left;
      font-size: 0.8em;
      margin: 0 10px;
      width: calc(50% - 20px);
    }
  }
</style>



// WEBPACK FOOTER //
// services-vpo.vue?77080c2e